import {t, Trans} from '@lingui/macro'
import Helmet from 'react-helmet'
import {Link as RouterLink} from 'react-router-dom'

import {Button, Inline, Stack, Text, tokens} from '@pleo-io/telescope'
import {Clock} from '@pleo-io/telescope-icons'

import {InlineWistiaVideo} from '@product-web/telescope-lab/wistia-video/inline-wistia-video'
import {Page} from '@product-web-features/ui-page'

import {useSideOverview} from './use-side-overview'

import {SplitContent} from '../../../../components/split-content'
import {useAcademyContext} from '../../components/academy-context/academy-context'
import {SideOverview} from '../../components/side-overview'
import thumbnailSvg from '../../images/future-of-spend-thumbnail.svg'

export const Introduction = () => {
    const {country} = useAcademyContext()
    const {overviewSteps, usefulMaterials} = useSideOverview()
    const getVideoId = () => {
        // TODO get missing content from Marketing
        switch (country) {
            case 'DE':
            case 'DK':
            case 'GL':
            case 'SE':
            default:
                // default is GB, IE, US
                return '449k2810qn'
        }
    }

    return (
        <>
            <Helmet>
                <title>{t`Introduction to Pleo`}</title>
            </Helmet>
            <Page.Header>
                <Page.SpaceBetween>
                    <Page.Title>
                        <Trans>Introduction to Pleo</Trans>
                    </Page.Title>
                </Page.SpaceBetween>
                <Inline alignItems="center" space={6} mb={8}>
                    <Clock size={16} color={tokens.colorContentStaticQuiet} />{' '}
                    <Text color="colorContentStaticQuiet">
                        <Trans>3 mins</Trans>
                    </Text>
                </Inline>
                <SplitContent>
                    <SplitContent.Main>
                        <Text>
                            <Trans>
                                Hi, we're Pleo, Europe's leading business spend management solution.
                                We help companies of all shapes and sizes spend smarter and safer.
                                This all starts with our Business Expense Cards.
                            </Trans>
                        </Text>
                    </SplitContent.Main>
                    <SplitContent.Right></SplitContent.Right>
                </SplitContent>
            </Page.Header>
            <SplitContent>
                <SplitContent.Main>
                    <Stack space={16}>
                        <Text as="h2" variant="2xlarge-accent" space={4}>
                            <Trans>Introduction</Trans>
                        </Text>
                        <InlineWistiaVideo
                            ariaLabel={t`Play video: Beyond - The future of spend management`}
                            thumbnail={{src: thumbnailSvg}}
                            videoId={getVideoId()}
                            autoPlay={false}
                        />
                    </Stack>
                    <Inline alignItems="center" justifyContent="space-between" mt={16}>
                        <Button
                            aria-label={t`Back`}
                            variant="link-secondary"
                            as={RouterLink}
                            to="../"
                        >
                            &larr; <Trans>Back</Trans>
                        </Button>
                        <Button aria-label={t`Next`} variant="primary">
                            <Trans>Next</Trans> &rarr;
                        </Button>
                    </Inline>
                </SplitContent.Main>
                <SplitContent.Right>
                    <SideOverview overviewSteps={overviewSteps} usefulMaterials={usefulMaterials} />
                </SplitContent.Right>
            </SplitContent>
        </>
    )
}
